export default __webpack_public_path__ + "static/media/videoJd1.d45188e9.mp4";